import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {commonActions, inboxActions} from "../../../../../store/actions";
import moment from "moment";
import {commons} from "../../../../../hook/common";

/*
   간접수출실적증명서 form
 */
const InboxForm2 = props => {
  const [ state, setState ] = useState({});
  const [ commoncode, setCommoncode ] = useState({});

  useEffect(() => {
    props.getCommonCode({mainCd:['CRT_FORM_TP', 'CRT_PERFORM_TP', 'CRT_SUBMIS_TP']});
  }, []);

  useEffect(() => {
    setCommoncode({
      ...commoncode,
      ...props.commoncode
    });

    setState({
      ...state,
      docFormatNm: props.commoncode?.CRT_FORM_TP?.find(co => co.cd === props.data?.docFormat)?.cdName,
      docTypeNm: props.commoncode?.CRT_SUBMIS_TP?.find(co => co.cd === props.data?.submisType)?.cdName,
      submissionNm: props.commoncode?.CRT_SUBMIS_TP?.find(co => co.cd === props.data?.submission)?.cdName
    })

    // commonList.CRT_FORM_TP &&
    // props.commoncode?.CRT_FORM_TP?.forEach((i) => {
    //   console.log(i)
    // })

    // props.commoncode?.CRT_FORM_TP?.find(co => co.cd === props.data?.docFormat).cdName
    // props.commoncode?.CRT_SUBMIS_TP?.find(co => co.cd === props.data?.submisType).cdName
    // props.commoncode?.CRT_SUBMIS_TP?.filter(co => co.cd === props.data?.submission).cdName
  },[props.commoncode])

  // useEffect(() => {
  //   // 공통코드 로딩 시점 이슈로 인해 useEffect로 처리
  //   if (Object.keys(props.data).length < 1 || !commoncode) return;
  //
  // },[props.data])

  return (
    <>
      <div className="detail-table-box" style={{marginTop: "1rem"}}>
        <div className="detail-title">일반정보</div>
        <div className="detail-table-scroll">
          <ul className="flex-col infor-detail">
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="title">서식유형</span>
                {/*<span>*/}
                {/*  {*/}
                {/*    props.commoncode?.CRT_FORM_TP?.find(co => co.cd === props.data?.docFormat) &&*/}
                {/*    props.commoncode?.CRT_FORM_TP?.find(co => co.cd === props.data?.docFormat).cdName*/}
                {/*  }*/}
                {/*</span>*/}
                <span>
                  {props.data?.docFormat}
                </span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="title">제출처분류</span>
                {/*<span>*/}
                {/*  {*/}
                {/*    props.commoncode?.CRT_SUBMIS_TP?.find(co => co.cd === props.data?.submisType) &&*/}
                {/*    props.commoncode?.CRT_SUBMIS_TP?.find(co => co.cd === props.data?.submisType).cdName*/}
                {/*  }*/}
                {/*</span>*/}
                <span>
                  {
                    props.data?.submisType === 'FRM001'?
                      '무역보험공사서식' :
                      (props.data?.submisType === 'FRM002'? '무역의날포상서식' : 
                        (props.data?.submisType === 'FRM003'? '대외무역법정서식' : '')
                      )                    
                  }
                </span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="title">제출처</span>
                {/*<span>{props.data?.submission}</span>*/}
                {/*<span>*/}
                {/*  {*/}
                {/*    props.commoncode?.CRT_SUBMIS_TP?.filter(co => co.cd === props.data?.submission) &&*/}
                {/*    props.commoncode?.CRT_SUBMIS_TP?.filter(co => co.cd === props.data?.submission).cdName*/}
                {/*  }*/}
                {/*</span>*/}
                <span>
                  {props.data?.submission}
                </span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="title">용도</span>
                <span>{props.data?.purpose}</span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="title">상호</span>
                <span>{props.data?.orgNm} | {props.data?.orgId}</span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="title">대표자명</span>
                <span>{props.data?.orgCeoNm}</span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="title">주소</span>
                <span>({props.data?.orgZipCd}) | {props.data?.orgAddress}</span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="title">업종</span>
                <span>{props.data?.sector}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="detail-table-box">
        <div className="detail-title">실적정보</div>
        <div className="header">
          <ul>
            <li className="col status">번호</li>
            <li className="col text">구분</li>
            <li className="col text">실적구분</li>
            <li className="col date">확인(입금)일자</li>
            <li className="col number">발급(매입)번호</li>
            <li className="col number">실적금액(원화)</li>
            <li className="col number">실적금액(USD)</li>
            <li className="col text">비고</li>
          </ul>
        </div>

        <div className="detail-table-scroll">
          <div className="inner">
            <div className="scroll">
              <div className="row">
                {
                  props.data?.performList?.length > 0 ?
                    props.data?.performList.map((perform, index) => (
                      <ul key={index}>
                        <li className="col status" data-title="번호"><span>{perform.crtCrtfSeq}</span></li>
                        <li className="col text" data-title="구분"><span>
                          {
                            perform.performtype === '01' ? '구매확인서' : (
                              perform.performtype === '02' ? '내국신용장' : '은행'
                            )
                          }
                          </span>
                        </li>
                        <li className="col text" data-title="품목명"><span>{perform.itemnm}</span></li>
                        <li className="col date" data-title="확인(입금)일자"><span>{perform.confirmdt && moment(perform.confirmdt, 'YYYYMMDD').format('YYYY.MM.DD')}</span></li>
                        <li className="col number" data-title="발급(매입)번호"><span>{perform.purchasenum}</span></li>
                        <li className="col number" data-title="실적금액(원화)"><span>{perform.performAmtKrw && commons.addComma(perform.performAmtKrw)}</span></li>
                        <li className="col number" data-title="실적금액(USD)"><span>{perform.performAmtUsd && commons.addComma(perform.performAmtUsd)}</span></li>
                        <li className="col text" data-title="비고"><span>{perform.remark}</span></li>
                      </ul>
                  )) : ''
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      { props.data?.attachGroupId &&
      <div className="detail-table-box">
        <div className="detail-title">첨부파일</div>
        <div className="detail-table-scroll">
          <div className="inner">
            <div className="scroll">
              <div className="row">
                {
                  props.data?.attachList?.length > 0 ?
                    props.data?.attachList.map((attach, index) => (
                      <ul key={index}>
                        <li className="col text">
                          <a href={'/portal/file/'+ attach?.fileId} download title="파일다운로드">{attach.originFileNm}</a>
                        </li>
                      </ul>
                    )) : ''
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      }

      <div className="detail-table-box">
        <div className="detail-title">발급이력</div>
        <div className="detail-table-scroll">
          <ul className="flex-col infor-detail">
            <li className="row w-100 item">
                <div className="flex-row w-full">
                  <span className="title">발급일자</span>
                  <span>{props.data?.issuedt && moment(props.data?.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD')}</span>
                </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => {
  return {
    commoncode: state.commoncode?.co,
  }
}

const actionCreators = {
  getCommonCode : commonActions.getCommonCode,
  getFile: inboxActions.getFile
}

export default connect(
  mapStateToProps,
  actionCreators
)(InboxForm2)
